<!--
 <Object :objectCode="offer.rentalObjectCode">
 </Object>
-->
<template>
  <div class="object" :class="typeCaption">
    <div
      class="object__inner"
      :class="{
        'object__inner--isLoading': showLoader,
        'object__inner--reset': reset,
      }"
    >
      <router-link
        class="object-btn"
        :class="typeCaption"
        :to="{
          name: 'Vacancy',
          params: { id: rentalObjectCode },
          query: $route.query,
        }"
      >
        <div class="object-list-item">
          <div class="image-container" :class="typeCaption">
            <img
              :src="image"
              alt=""
              class="box-image"
              v-if="typeCaption !== 'Lokal' && typeCaption !== 'Fordonsplats'"
            />
            <div class="rental-marker" :class="subtypeCaptionClass">
              {{ subtypeCaption }}
            </div>
          </div>
          <div class="object-text object-text__flex">
            <div class="object-text__column">
              <div class="object-text__inner">
                <div class="object-text__flex">
                  <div class="object-text__flex-inner">
                    <h4>
                      {{ address }}
                      <span v-if="staircase && staircase != 'BV'">, våning {{ staircase }}</span>
                      <span v-if="staircase == 'BV'">{{ staircase }}</span>
                      <!--Sörbygatan 25 -->
                    </h4>
                  </div>
                </div>
                <span class="object-text__neighbourhood">{{ neighbourhood }}</span>
              </div>
              <div class="object-info">
                <div class="object-info-subcaption" v-if="typeCaption != 'Lokal'">
                  <!-- 1 rum och kök -->
                  {{ subCaption }}
                </div>
                <div class="area" v-if="quantityBRA && typeCaption != 'Fordonsplats'">
                  {{ quantityBRA }} m²
                  <!-- 25.5 m2 -->
                </div>
                <div class="area" v-if="parkingNumber">Plats {{ parkingNumber }}</div>
                <div class="divider" v-if="!parkingNumber && !quantityBRA"></div>
                <div class="object-info-rent">
                  {{ addSpace(getPrice(monthRent, vatArea, subCaption, typeCaption)) }}
                  kr/månad {{ addAsterisk() }}
                  <!-- 2000 kr/månad -->
                </div>
              </div>
            </div>
          </div>
          <div class="dot"><span class="dot__arrow" /></div>
        </div>
        <div class="object-text__vacantfrom">
          <span>Tillträde: {{ vacantFromText }}</span>
          <!--<div v-if="fastAccess" class="object-text__fast-access">Snabb inflytt</div>-->
        </div>
      </router-link>
    </div>
    <div v-if="totalPoi > 1" class="ol-popup__nav">
      <a class="ol-popup__nav__btn ol-popup__nav__btn--previous" @click="getPoiInfo('prev')">
        <span></span>
      </a>
      <div>{{ currentPoi }} av {{ totalPoi }}</div>
      <a class="ol-popup__nav__btn ol-popup__nav__btn--next" @click="getPoiInfo('next')">
        <span></span>
      </a>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/ui/loader';
import RentalObjectMixin from '@/mixins/rentalobject';
import GeneralMixin from '@/mixins/general';
import { PARKING_FILTER_TYPES } from '@/config/constants';

export default {
  mixins: [RentalObjectMixin, GeneralMixin],
  components: { Loader },
  props: {
    rentalObject: {
      type: Array,
      required: false,
    },

    objectCode: {
      type: String,
      required: false,
    },
    overlayOpen: {
      required: false,
    },
  },

  data() {
    return {
      showLoader: true,
      reset: false,
      totalPoi: this.rentalObject.length,
      currentPoi: 1,
    };
  },
  computed: {
    _rentalObject() {
      this.totalPoi = this.rentalObject.length;
      if (this.rentalObject) {
        return this.rentalObject[this.currentPoi - 1];
      } else {
        return this.$store.getters.getObjectByObjectCode(this.objectCode);
      }
    },
  },
  watch: {
    overlayOpen: {
      handler() {
        this.currentPoi = 1;
      },
    },
  },
  methods: {
    getPoiInfo(dir) {
      this.showLoader = true;
      setTimeout(() => {
        this.reset = true;
        this.showLoader = false;
        if (dir == 'next') {
          this.currentPoi++;
          if (this.currentPoi > this.totalPoi) this.currentPoi = 1;
        } else {
          this.currentPoi--;
          if (this.currentPoi < 1) this.currentPoi = this.totalPoi;
        }
      }, 200);

      setTimeout(() => {
        this.reset = false;
        this.showLoader = false;
      }, 400);
    },

    getPrice(monthRent, vatArea) {
      if (
        PARKING_FILTER_TYPES['CAR'].includes(this.rentalObject.rentalObjectType)
      ) {
        if (this._rentalObject.vatAdded != true) {
          return Math.round(monthRent * 1.25);
        }
      }
      return monthRent;
    },

    addAsterisk() {
      /*if (!this.authStatus && PARKING_FILTER_TYPES['CAR'].includes(this.rentalObject.rentalObjectType)) {
          return "*";
        }*/
      return '';
    },
  },

  created() {
    if (this.objectCode) {
      return this.$store.dispatch('fetchSingleRentalObject', this.objectCode).finally(() => {
        this.showLoader = false;
      });
    } else if (this.rentalObject) {
      this.showLoader = false;
    } else {
      console.error('rentalobjectmap.vue Varken rentalObject eller objectCode satt :(');

      this.showLoader = false;
    }
  },
};
</script>

<style lang="scss" scoped>

.object {
  cursor: auto !important;
  width: 385px;
  max-width: calc(100vw - 40px);
  background-color: $backgroundcolorwhite;

  &__inner {
    transition: all 0.3s;
    margin-left: 0;
    opacity: 1;

    &--isLoading {
      opacity: 0;
      margin-left: -10px;
    }

    &--reset {
      opacity: 0;
      margin-left: 15px;
    }
  }

  &.Lokal .area {
    border-left: none;
    margin-left: 0;
    padding-left: 0;
  }
}

.vacancy-module .image-container, .search-module .image-container {
  width: 135px;
  height: 135px;
  overflow: hidden;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}

.object-text__neighbourhood {
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.64px;
  text-transform: uppercase;
}

.object-text__vacantfrom {
  text-align: right;
  background-color: $lightgray;
  padding: 11px 11px 11px 15px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  span {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .object-text__fast-access {
    margin-top: 0;
  }
}

.dot {
  transition: all 0.3s;
  opacity: 0;
  height: 154px;
  width: 154px;
  background-color: $abglightblue;
  border-radius: 50%;
  position: absolute;
  top: -85px;
  right: -82px;

  .dot__arrow {
    transition: all 0.4s ease-in-out;
    display: block;
    background-image: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-arrow.svg);
    width: 24px;
    height: 24px;
    margin-left: 12px;
    opacity: 0;
    margin-top: 102px;
  }
}

a.object-btn {
  text-decoration: none !important;
  color: $textcolorblack;
}

a:hover {
  @media (min-width: 800px) {
    .dot {
      opacity: 1;
      top: -85px;
      right: -82px;
    }

    .dot__arrow {
      margin-left: 31px;
      opacity: 1;
    }
  }
}


.object-text {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(100% - 135px); //100% - image width
  padding: 12px 14px;

  .Lokal &, .Fordonsplats &{
    width: 100%;
  }

  h4, h4 span {
    font-size: 16px;
    font-weight: bold;
    text-align: left;

    .Bostad &  {
      max-width: 175px;
    }
  }

  .object-text__inner {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .object-text__flex {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .object-text__column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    z-index: 1;
  }

  .object-text__flex-inner {
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.object-text__fast-access {
  border-radius: 2px;
  background-color: $abgyellow;
  padding: 1px 4px 2px 5px;
  white-space: nowrap;

  font-size: 12px;
  text-transform: uppercase;
  line-height: 16px;
  letter-spacing: 0.36px;
  font-weight: bold;

  display: inline-block;
  margin-left: 12px;
  margin-top: 5px;
}

.object.Fordonsplats {

  .object-info-subcaption {
    padding: 5px 8px;
    border: 1px solid $gray;
    font-size: 14px;
    font-weight: 600;
  }

  .area {
    border-left: none!important;
    padding-left: 0!important;
  }

  .object-info {
    margin-top: 9px;
  }
}


.object-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;

  > div {
    color: $textcolorgray;
    font-size: 14px;
    letter-spacing: 0.08px;
    font-weight: bold;
  }

  .area {
    margin-left: 8px;
    margin-right: 8px;
    padding-left: 8px;
    padding-right: 8px;
    border-left: 1px solid $gray;
    font-weight: 600;
  }

  .divider {
    margin-right: 8px;
    padding-right: 8px;
    border-right: 1px solid $gray;
    font-weight: normal;
  }
}

.object-list-item {
  display: flex;
  flex-direction: row;
  border: 1px solid $lightgray;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.image-container {
  position: relative;
  padding-top: 0;
  margin-bottom: 0;

  &.Fordonsplats, &.Lokal {
    display: none;
  }


  .rental-marker {
    position: absolute;
    bottom: 8px;
    left: 10px;
    top: initial;
    padding: 6px 12px;
    color: $textcolorgray;
    border-radius: 2px;
    border: 1px solid $lightgray;
    background-color: $backgroundcolorwhite !important;
    max-width: 85%;
    font-size: 12px;
  }
}


.ol-popup {

  &__nav {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    border-top: solid 1px rgba(157, 157, 156, 0.5);
    background-color: $lightgray;
    font-size: 14px;
    letter-spacing: 0.07px;
    align-items: center;

    &__btn {
      width: 40px;
      height: 100%;
      background-color: $lightgray;
      cursor: pointer;

      &:hover {
        background-color: $turquise;

        span {
          border-color: $textcolorwhite;
        }
      }

      span {
        display: inline-block;
        margin-top: 13px;
        border: solid black;
        border-width: 0 2px 2px 0;
        padding: 3px;
      }

      &--next {
        border-left: 1px solid $midgray;
        border-right: none;

        span {
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
        }
      }

      &--previous {
        border-right: 1px solid $midgray;
        border-left: none;

        span {
          transform: rotate(135deg);
          -webkit-transform: rotate(135deg);
        }
      }
    }
  }
}

</style>
